import { Domain, Component, RubricService, RubricVersionDto } from "@/generated/api.clients";
import Api from '@/plugin/Api';
import { Ref, ref } from "@vue/composition-api";

export class RubricHelper {
  _version: Ref<RubricVersionDto | undefined> = ref(undefined)
  _service: RubricService

  constructor() {
    this._service = new RubricService(undefined, Api)
  }

  async loadRubricVersion(id: number): Promise<void> {
    console.log(`Loading Rubric Version ${id}`)
    this._version.value = await this._service.getRubricVersion(id);
  }

  domain(domainKey: string): Domain | undefined{
    return this._version.value?.metadata?.domains?.find(d=>d.key == domainKey)
  }

  component(domainKey: string, componentKey: string): Component | undefined {
    return this._version.value?.metadata?.domains?.find(d=>d.key == domainKey)?.components?.find(c=>c.key == componentKey)
  }

  domainName(domainKey: string): string | undefined {
    return this.domain(domainKey)?.name
  }

  componentName(domainKey: string, componentKey:string): string | undefined {
    return this.component(domainKey, componentKey)?.name
  }
}